<template>
  <div class="employees">
    <h1 class="py-0 text-left mb-5">{{ this.info.nombre }}</h1>


   
              
          <v-row>
          
          <v-col cols="12" class="text-right" md="12">    <v-btn text right class="secondary" color="white" @click="config">
              <v-icon dark>
                  mdi-tools
                </v-icon>  Configuración
      </v-btn>
      
       <v-btn text right class="ml-2 secondary" color="white" @click="contract">
              <v-icon dark>
                  mdi-file-document-multiple-outline
                </v-icon>  Contrato
      </v-btn>
      
       </v-col>
        <v-col cols="12" md="6">
          <v-card class="mx-auto" outlined>
            <v-list-item class="pa-5">
              <v-list-item-avatar>
                <v-icon class="secondary lighten-1" dark>
                  mdi-{{ this.info.icon }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-left headline mb-1">
                  Colaboradores
                </v-list-item-title>
              </v-list-item-content>


                <span class="primary--text headline font-weight-bold">{{ this.info.items }}</span>

            </v-list-item>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text right color="secondary" :to="`/areas/${this.info.id}/employees`">
                ver más
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        
      <v-col cols="12" md="6">
          <v-card class="mx-auto" outlined>
            <v-list-item class="pa-5">
              <v-list-item-avatar>
                <v-icon class="secondary lighten-1" dark>
                  mdi-file-document-multiple-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-left headline mb-1">
                  Contratos
                </v-list-item-title>
              </v-list-item-content>


                <span class="primary--text headline font-weight-bold">{{ this.info.contratos }}</span>

            </v-list-item>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text right color="secondary" :to="`/areas/${this.info.id}/contracts`">
                ver más
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        
      </v-row>
      

<!-- Dialog Contract - Edit -->
    <v-dialog v-model="dialogContract" persistent width="900">
      <v-card>
        <v-card-title> Editar Contrato </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formContract" v-model="formContract">
            <v-container>
              <v-row>
     
                  <v-col cols="12" height="600" md="12">
                  <v-textarea
                    v-model="contractModel.blade"
                    rows="20"
                    :rules="[this.$store.state.rules.required]"
                    label="Contrato"

                  ></v-textarea>
                </v-col>

           
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="closeContract">Cerrar</v-btn>
          <v-btn
            text
            color="success"
            @click="updateContractBlade"

            >Actualizar</v-btn
          >
         
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    
  <!-- Dialog Show - Edit -->
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <v-card-title> Editar Configuración </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formConfiguration" v-model="formConfiguration">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.validity"
                    :rules="[this.$store.state.rules.required]"
                    label="Vigencia"

                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.validitySince"
                        label="Vigencia Desde"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        :rules="[(v) => !!v || 'Campo obligatorio']"

                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.validitySince"
                      @input="menuStartDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.validityUntil"
                        label="Vigencia Hasta"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        :rules="[(v) => !!v || 'Campo obligatorio']"

                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.validityUntil"
                      @input="menuEndDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.contract_reference"
                    :rules="[this.$store.state.rules.required]"
                    label="Contrato"

                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.contract_consecutive"
                    :rules="[this.$store.state.rules.required]"
                    label="Cons. Contratos"

                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.bill_consecutive"
                    :rules="[this.$store.state.rules.required]"
                    label="Cons. Cuentas"

                  ></v-text-field>
                </v-col>

                
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="close">Cerrar</v-btn>
          <v-btn
            text
            color="success"
            @click="updateConfiguration"

            >Actualizar</v-btn
          >
         
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
/* import { SET_ALERT } from "@/store/alert"; */

import { SET_ALERT } from "@/store/alert";
import { SET_CONTRACT, SET_INFO } from "@/store/areas";

export default {
  name: "Areas",
  filters: {

  },
  
  data: () => ({
    dialog: false,
    dialogContract: false,
    info: [],
    formConfiguration: true,
    formContract: true,
    menuEndDate: null,
    menuStartDate: null,
    activeDelete: false,    
    currentArea: false,
    model: {
      bill_consecutive: "",
      contract_reference: "",
      contract_consecutive: "",
      validitySince: "",
      validityUntil: "",
      validity: "",
    },
    contractModel: {
      blade: "",
    },
  }),
  created() {
    this.$store.dispatch("getAreaInfo");
    console.log(this.$store.state);
    this.$store.subscribe((mutation) => {
      if (mutation.type === SET_INFO) {
      this.info = this.$store.state.areas.info;

      
        this.model = {
        bill_consecutive: this.$store.state.areas.info.config.bill_consecutive,
        contract_reference: this.$store.state.areas.info.config.contract_reference,
        contract_consecutive: this.$store.state.areas.info.config.contract_consecutive,
        validitySince: this.$store.state.areas.info.config.validitySince,
        validityUntil: this.$store.state.areas.info.config.validityUntil,
        validity: this.$store.state.areas.info.config.validity,
        status: this.$store.state.areas.info.config.status,
      };
      
      }
    });
  },

  methods: {
     contract() {
      this.$store.dispatch("getAreaContract");
    this.$store.subscribe((mutation) => {
      if (mutation.type === SET_CONTRACT) {


      
        this.contractModel = {
        blade: this.$store.state.areas.contract.file,
       
      };
      
      }
    });
    
      this.dialogContract = true;
      
    },  
    config() {
      this.dialog = true;
    },
   close() {
      this.dialog = false;
    },
   closeContract() {
      this.dialogContract = false;
    },
    async updateConfiguration() {
    console.log(this.$store.state.areas.info);
    
      if (!this.$refs.formConfiguration.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.$store.dispatch("updateConfiguration", {
        id: this.$store.state.areas.info.config.id,
        form: this.model,
      });
      this.close();
    },
    async updateContractBlade() {

    
      if (!this.$refs.formContract.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.$store.dispatch("updateContractBlade", {
        form: this.contractModel,
      });
      this.closeContract();
    },
  },
};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
